export function menu() {
  $jq3('.hamburger').on('click', function(e) {
    e.preventDefault();

    $jq3('.hamburger').addClass('is-active');
    $jq3('.menu__container').addClass('menu__container--is-active');
    $jq3('.menu__overlay').addClass('menu__overlay--is-active');
  });

  $jq3('.menu__close-button').on('click', function(e) {
    e.preventDefault();

    $jq3('.hamburger').removeClass('is-active');
    $jq3('.menu__container').removeClass('menu__container--is-active');
    $jq3('.menu__overlay').removeClass('menu__overlay--is-active');
    $jq3('.menu__item').removeClass('menu__item--is-open');
    $jq3('.menu__container').removeClass('menu__container--submenu-open');
  });

  $jq3('.menu__overlay').on('click', function(e) {
    e.preventDefault();

    $jq3('.hamburger').removeClass('is-active');
    $jq3('.menu__container').removeClass('menu__container--is-active');
    $jq3('.menu__overlay').removeClass('menu__overlay--is-active');
    $jq3('.menu__item').removeClass('menu__item--is-open');
    $jq3('.menu__container').removeClass('menu__container--submenu-open');
  });
/*
  $jq3('.menu__item')
    .on('click', function(e) {
      if (!$jq3(this).find('.menu__direct-link').length) {
        e.preventDefault();

        const currentItem = $jq3(this);
        $jq3('.menu__item')
          .not(currentItem)
          .removeClass('menu__item--is-open');
        currentItem.toggleClass('menu__item--is-open');

        if (currentItem.hasClass('menu__item--is-open')) {
          $jq3('.menu__container').addClass('menu__container--submenu-open');
        } else {
          $jq3('.menu__container').removeClass('menu__container--submenu-open');
        }
      } else {
        const href = $jq3(this)
          .find('a')
          .attr('href');

        if (href !== undefined) window.location.href = href;
      }
    })
    .children()
    .click(function(e) {
      return false;
    });

  $jq3('.menu__link').on('click', function(e) {
    e.stopPropagation();
  });

  $jq3('.menu__list--child').on('click', function(e) {
    const href = $jq3(this)
      .find('a')
      .attr('href');

    if (href !== undefined) window.location.href = href;
  });

  $jq3('.menu__back-button').on('click', function(e) {
    e.preventDefault();

    $jq3('.menu__item').removeClass('menu__item--is-open');
    $jq3('.menu__container').removeClass('menu__container--submenu-open');
  });

  $jq3('.menu__contact-container').on('click', function(e) {
    const href = $jq3(this)
      .find('a')
      .attr('href');

    if (href !== undefined) window.location.href = href;
  });


 */
}
